import { render, staticRenderFns } from "./CompeteExpence.vue?vue&type=template&id=ba83d634&scoped=true&"
import script from "./CompeteExpence.vue?vue&type=script&lang=js&"
export * from "./CompeteExpence.vue?vue&type=script&lang=js&"
import style0 from "./CompeteExpence.vue?vue&type=style&index=0&id=ba83d634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba83d634",
  null
  
)

export default component.exports